// ============================================
// OLA Cosmetics - Premium Animations
// GSAP ScrollTrigger ONLY (no Lenis - it conflicts)
// ============================================

(function() {
  'use strict';

  var retries = 0;
  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      if (retries++ < 30) { setTimeout(init, 150); return; }
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // ---- SCROLL REVEAL for .reveal elements ----
    gsap.utils.toArray('.reveal').forEach(function(el) {
      gsap.fromTo(el,
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.9, ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 92%', toggleActions: 'play none none none' }
        }
      );
    });

    // ---- PRODUCT CARDS stagger ----
    var fpCards = gsap.utils.toArray('.fp-card');
    if (fpCards.length) {
      fpCards.forEach(function(card, i) {
        gsap.fromTo(card,
          { y: 50, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.7, ease: 'power2.out', delay: i * 0.08,
            scrollTrigger: { trigger: card, start: 'top 95%', toggleActions: 'play none none none' }
          }
        );
      });
    }

    // ---- CATEGORY TILES scale in ----
    gsap.utils.toArray('.category-tile').forEach(function(tile, i) {
      gsap.fromTo(tile,
        { scale: 0.9, opacity: 0 },
        { scale: 1, opacity: 1, duration: 0.7, ease: 'power2.out', delay: i * 0.1,
          scrollTrigger: { trigger: tile, start: 'top 92%', toggleActions: 'play none none none' }
        }
      );
    });

    // ---- TRUST ICONS stagger ----
    gsap.utils.toArray('.trust-icons__item').forEach(function(item, i) {
      gsap.fromTo(item,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.6, ease: 'power2.out', delay: i * 0.12,
          scrollTrigger: { trigger: item, start: 'top 95%', toggleActions: 'play none none none' }
        }
      );
    });

    // ---- COLLECTION LIST items slide in ----
    gsap.utils.toArray('.collection-list-hover__item').forEach(function(item, i) {
      gsap.fromTo(item,
        { x: 60, opacity: 0 },
        { x: 0, opacity: 1, duration: 0.8, ease: 'power3.out', delay: i * 0.1,
          scrollTrigger: { trigger: item, start: 'top 92%', toggleActions: 'play none none none' }
        }
      );
    });

    // ---- BLOG CARDS stagger ----
    gsap.utils.toArray('.blog-post-card').forEach(function(card, i) {
      gsap.fromTo(card,
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.7, ease: 'power2.out', delay: i * 0.12,
          scrollTrigger: { trigger: card, start: 'top 95%', toggleActions: 'play none none none' }
        }
      );
    });

    // ---- TESTIMONIALS fade in ----
    var testi = document.querySelector('.testi-wonder');
    if (testi) {
      gsap.fromTo(testi,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8, ease: 'power2.out',
          scrollTrigger: { trigger: testi, start: 'top 92%', toggleActions: 'play none none none' }
        }
      );
    }

    // ---- NEWSLETTER scale up ----
    var news = document.querySelector('.newsletter-wonder');
    if (news) {
      gsap.fromTo(news,
        { scale: 0.95, opacity: 0 },
        { scale: 1, opacity: 1, duration: 0.8, ease: 'power2.out',
          scrollTrigger: { trigger: news, start: 'top 92%', toggleActions: 'play none none none' }
        }
      );
    }

    // ---- HERO TEXT: word-by-word entrance ----
    var heroH = document.querySelector('.hero-text-block__heading');
    if (heroH && heroH.textContent.trim()) {
      var words = heroH.textContent.trim().split(/\s+/);
      heroH.innerHTML = words.map(function(w) {
        return '<span style="display:inline-block;overflow:hidden;vertical-align:bottom;"><span class="hw" style="display:inline-block;">' + w + '</span></span>';
      }).join(' ');
      gsap.from(heroH.querySelectorAll('.hw'), {
        y: '100%', duration: 0.8, ease: 'power4.out', stagger: 0.06, delay: 0.2
      });
    }

    // ---- HERO SUB + CTA (fast entrance) ----
    var heroSub = document.querySelector('.hero-text-block__sub');
    var heroCta = document.querySelector('.hero-text-block .btn');
    if (heroSub) gsap.from(heroSub, { y: 15, opacity: 0, duration: 0.6, delay: 0.6 });
    if (heroCta) gsap.from(heroCta, { y: 15, opacity: 0, duration: 0.6, delay: 0.8 });

    // ---- HERO NO-IMAGE HEADLINE ----
    var heroNoImg = document.querySelector('.hero-banner__no-image-headline');
    if (heroNoImg) gsap.from(heroNoImg, { y: 60, opacity: 0, duration: 1.5, ease: 'power4.out', delay: 0.3 });

    // ---- IMAGE TILT ON HOVER ----
    document.querySelectorAll('.fp-card__image-wrap, .category-tile__image-wrap, .hover-zoom').forEach(function(wrap) {
      wrap.addEventListener('mousemove', function(e) {
        var r = wrap.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        var img = wrap.querySelector('img');
        if (img) gsap.to(img, { x: x * -8, y: y * -8, scale: 1.06, duration: 0.3 });
      });
      wrap.addEventListener('mouseleave', function() {
        var img = wrap.querySelector('img');
        if (img) gsap.to(img, { x: 0, y: 0, scale: 1, duration: 0.5, ease: 'power2.out' });
      });
    });

    // ---- MAGNETIC BUTTONS ----
    document.querySelectorAll('.btn, .btn--dark').forEach(function(btn) {
      btn.addEventListener('mousemove', function(e) {
        var r = btn.getBoundingClientRect();
        gsap.to(btn, { x: (e.clientX - r.left - r.width/2) * 0.12, y: (e.clientY - r.top - r.height/2) * 0.12, duration: 0.3 });
      });
      btn.addEventListener('mouseleave', function() {
        gsap.to(btn, { x: 0, y: 0, duration: 0.5, ease: 'elastic.out(1, 0.5)' });
      });
    });

    // ---- COLLECTION HOVER letter spacing ----
    document.querySelectorAll('.collection-list-hover__link').forEach(function(link) {
      link.addEventListener('mouseenter', function() { gsap.to(link, { letterSpacing: '0.15em', duration: 0.3 }); });
      link.addEventListener('mouseleave', function() { gsap.to(link, { letterSpacing: '0em', duration: 0.3 }); });
    });

    // ---- PARALLAX IMAGES ----
    document.querySelectorAll('.parallax-text-section__image--left').forEach(function(img) {
      gsap.fromTo(img, { y: 80 }, { y: -60, ease: 'none', scrollTrigger: { trigger: img.parentElement, start: 'top bottom', end: 'bottom top', scrub: 1.5 } });
    });
    document.querySelectorAll('.parallax-text-section__image--right').forEach(function(img) {
      gsap.fromTo(img, { y: 120 }, { y: -80, ease: 'none', scrollTrigger: { trigger: img.parentElement, start: 'top bottom', end: 'bottom top', scrub: 1.5 } });
    });

    // ---- SMOOTH SCROLL (native, enhanced) ----
    document.documentElement.style.scrollBehavior = 'smooth';

    console.log('OLA Premium Animations: OK');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
